import axios from "axios";

const host = (process.env.NEXT_PUBLIC_HOST || "").replace(/^https?:\/\//, "");
const isLocalHost = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?$/.test(host);
const RU_EDGE_HOST = "ru.chesshotel.com";
const DIRECT_API_HOST = "direct.chesshotel.com";
export const USE_PROD = !isLocalHost;

function getApiHost() {
  if (
    USE_PROD &&
    typeof window !== "undefined" &&
    window.location.hostname === RU_EDGE_HOST
  ) {
    return DIRECT_API_HOST;
  }

  return host;
}

export let BASE_URL = USE_PROD
  ? "https://" + getApiHost() + "/api/v1/"
  : "http://" + host + ":3002/api/v1/";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});

export const puzzleApi = axios.create({
  baseURL: "https://www.chesshotel.com/api/v1/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "production" ? 10000 : 10000000,
});
